/* =====================================================================
   hilfe-center.js · B6-7 V3 · Hilfe-Center für myteslatuning.de/hilfe

   Eine Datei, keine Abhängigkeiten, kein Framework. Die komplette Ansicht
   wird hier aufgebaut, damit die Shopify-Seite und die Vorschau-Datei
   garantiert dasselbe zeigen und nicht auseinanderlaufen können.

   V3 (26.07.2026), aus Johns Rückmeldung zur V2-Vorschau:
     * Die 62 selbst geschriebenen Fragen je Produktgruppe sind raus. Sie
       lasen sich wie eine Mängelliste ("Hält die Matte auch Flüssigkeit
       zurück?") und standen ausgerechnet auf der Seite, die Kunden NACH
       dem Kauf aufrufen. Der Anzeigeweg bleibt, aber er ist rein
       datengetrieben: liegt zu einer Gruppe keine ECHTE Frage vor,
       erscheint an dieser Stelle gar nichts, kein leerer Abschnitt und
       keine Überschrift.
     * Acht allgemeine Fragen statt sechs, alle neu geschrieben.
     * Suchfeld sitzt in einem eigenen Container, Fragen laufen als Liste
       (siehe hilfe-center.css, Abschnitt "Fragen").

   V2 (26.07.2026):
     * Bildunterschrift zum Erklärbild als echter Seitentext statt im Bild
     * eigener Abschnitt "Anleitung" je Artikel, mit ehrlichem Platzhalter
     * Anrede: die Seite duzt wie der Shop, NUR die Bestätigung nach dem
       Absenden siezt (Johns Doppelregel: Newsletter duzt, Support siezt)

   Erwartet vorher gesetzt:
     window.HILFE_KONFIG = {
       indexUrl : '…/hilfe-index.json',   // entfällt, wenn HILFE_INDEX gesetzt ist
       endpunkt : 'https://…/functions/v1/hilfe-anfrage',
       anonKey  : '',                      // optional, öffentlicher Schlüssel
       bildUrl  : '…/wo-ist-die-sku.png',
       demo     : false                    // true = Formular sendet nicht wirklich
     }
     window.HILFE_INDEX = { … }            // optional, spart den Netzabruf

   Suche: läuft komplett im Browser über einen einmal geladenen Index.
   Kein Netzabruf je Tastendruck, damit die Seite auch im Parkhaus mit
   einem Balken Empfang noch bedienbar ist.
   ===================================================================== */
(function () {
  'use strict';

  var K = window.HILFE_KONFIG || {};
  var WURZEL = null;
  var ARTIKEL = [];
  var FAQ_GLOBAL = [];
  var FAQ_SKU = {};
  var FAQ_GRUPPE = {};
  var GRUPPEN = {};
  var LETZTE_TREFFER = [];
  var LETZTE_SUCHE = '';
  var AKTUELLER_ARTIKEL = null;
  var CHAT_GEPRUEFT = false;

  var MAX_TREFFER = 25;
  var SCHWELLE = 0.44;

  /* ------------------------------------------------------------------
     Textwerkzeuge
     ------------------------------------------------------------------ */

  var KOMBI_ZEICHEN = new RegExp(
    '[' + String.fromCharCode(0x0300) + '-' + String.fromCharCode(0x036F) + ']', 'g');

  /** Alles auf eine vergleichbare Grundform bringen:
   *  klein, ohne Umlaute/Akzente, ß als ss, nur Buchstaben und Ziffern. */
  function falten(s) {
    if (!s) return '';
    var t = String(s).toLowerCase();
    t = t.replace(/ß/g, 'ss');
    if (t.normalize) {
      // NFD zerlegt "ä" in "a" + Kombinationszeichen, das dann wegfällt.
      // Bereich bewusst über Zeichencodes gebaut: als Regex-Literal stünden
      // hier unsichtbare Kombinationszeichen, die jedes Werkzeug anders
      // behandelt (Editor, Diff, Minifier).
      t = t.normalize('NFD').replace(KOMBI_ZEICHEN, '');
    } else {
      t = t.replace(/[äàáâãå]/g, 'a').replace(/[öòóôõ]/g, 'o')
           .replace(/[üùúû]/g, 'u').replace(/[éèêë]/g, 'e').replace(/[ç]/g, 'c');
    }
    t = t.replace(/[^a-z0-9]+/g, ' ');
    return t.replace(/\s+/g, ' ').trim();
  }

  function trigramme(s) {
    var t = ' ' + s + ' ';
    var menge = {};
    for (var i = 0; i + 3 <= t.length; i++) menge[t.substr(i, 3)] = true;
    return menge;
  }

  /** Jaccard-Ähnlichkeit zweier Trigramm-Mengen: 0 (nichts gemeinsam) bis 1. */
  function aehnlich(a, b) {
    if (a === b) return 1;
    if (a.length < 3 || b.length < 3) return a === b ? 1 : 0;
    var A = trigramme(a), B = trigramme(b);
    var schnitt = 0, k;
    for (k in A) if (B[k]) schnitt++;
    var vereinigung = Object.keys(A).length + Object.keys(B).length - schnitt;
    return vereinigung ? schnitt / vereinigung : 0;
  }

  function schuetzen(s) {
    return String(s === null || s === undefined ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  /** Nur harmlose Ziele durchlassen. Die Daten kommen zwar aus der eigenen
   *  Datenbank, aber eine Adresse landet in href/src und wäre damit der
   *  einzige Weg, aus einem Datenfeld ausführbaren Code zu machen. */
  function sichereUrl(u) {
    var s = String(u || '').trim();
    if (!s) return '';
    if (/^(https?:|mailto:|\/|\.\/)/i.test(s)) return schuetzen(s);
    // Eingebettete Rasterbilder: die Vorschau-Datei trägt das Erklärbild
    // als data-URI. SVG bleibt bewusst draußen, das kann Skript enthalten.
    if (/^data:image\/(png|jpe?g|gif|webp);base64,[a-z0-9+/=\s]+$/i.test(s)) return schuetzen(s);
    return '';
  }

  /* ------------------------------------------------------------------
     Index aufbauen
     ------------------------------------------------------------------ */
  function indexBauen(liste) {
    ARTIKEL = liste.map(function (a) {
      var titelWorte = falten(a.titel + ' ' + (a.variante || '')).split(' ');
      var synWorte = falten(a.synonyme || '').split(' ');
      var skuF = falten(a.sku);
      var skuFlach = skuF.replace(/ /g, '');
      var altF = falten(a.sku_alt || '');
      var altFlach = altF.replace(/ /g, '');

      var worte = {};
      titelWorte.forEach(function (w) { if (w.length > 1) worte[w] = 1.0; });
      // Synonyme zählen etwas weniger als der echte Titel, damit bei
      // gleich gutem Worttreffer der passendere Artikel oben steht.
      synWorte.forEach(function (w) { if (w.length > 1 && !worte[w]) worte[w] = 0.86; });

      return {
        sku: a.sku,
        sku_alt: a.sku_alt || '',
        titel: a.titel,
        variante: a.variante || '',
        bild_url: a.bild_url || '',
        kurzbeschreibung: a.kurzbeschreibung || '',
        anleitung_url: a.anleitung_url || '',
        anleitung_text: a.anleitung_text || '',
        anleitungen: a.anleitungen || [],
        gruppe: a.gruppe || '',
        produkt_url: a.produkt_url || '',
        elektro: !!a.elektro,
        _worte: Object.keys(worte).map(function (w) { return [w, worte[w]]; }),
        _skuFlach: skuFlach,
        _altFlach: altFlach
      };
    });
  }

  /** Bester Treffer eines Suchworts gegen alle Wörter eines Artikels. */
  function wortBewerten(frage, artikel) {
    var best = 0;
    for (var i = 0; i < artikel._worte.length; i++) {
      var wort = artikel._worte[i][0];
      var gewicht = artikel._worte[i][1];
      var wert = 0;

      if (wort === frage) {
        wert = 1;
      } else if (wort.indexOf(frage) === 0) {
        // Präfix: "kofferr" findet "kofferraum"
        wert = 0.93 - 0.1 * (1 - frage.length / wort.length);
      } else if (frage.length >= 4 && wort.indexOf(frage) > 0) {
        // Wortteil mitten drin: "matte" findet "allwettermatte"
        wert = 0.82;
      } else if (frage.length >= 5 && frage.indexOf(wort) === 0 && wort.length >= 4) {
        // Umgekehrt: "kofferraummatte" findet den Artikel über "kofferraum"
        wert = 0.8;
      } else if (frage.length >= 3) {
        var s = aehnlich(frage, wort);
        if (s >= 0.42) wert = 0.5 + s * 0.45;
      }

      wert *= gewicht;
      if (wert > best) best = wert;
      if (best >= 1) break;
    }
    return best;
  }

  function suchen(eingabe) {
    var q = falten(eingabe);
    if (!q) return [];
    var qFlach = q.replace(/ /g, '');
    var worte = q.split(' ').filter(function (w) { return w.length >= 2; });
    if (!worte.length) worte = [q];

    var ergebnis = [];
    for (var i = 0; i < ARTIKEL.length; i++) {
      var a = ARTIKEL[i];
      var summe = 0, verfehlt = 0;

      for (var j = 0; j < worte.length; j++) {
        var w = wortBewerten(worte[j], a);
        if (w < 0.4) verfehlt++;
        summe += w;
      }
      var punkte = summe / worte.length;

      // Ein einzelnes nicht passendes Wort soll den Treffer nicht killen
      // (Leute tippen "matte kofferraum schwarz"), aber deutlich abwerten.
      if (verfehlt > 0) punkte *= (verfehlt >= worte.length ? 0.2 : 0.72);

      // Artikelnummern schlagen alles: wer die Nummer vom Aufkleber
      // abtippt, will genau diesen einen Artikel sehen.
      if (qFlach.length >= 3) {
        if (a._skuFlach === qFlach) punkte = 3.0;
        else if (a._skuFlach.indexOf(qFlach) === 0) punkte = Math.max(punkte, 2.4);
        else if (a._altFlach && a._altFlach === qFlach) punkte = Math.max(punkte, 2.8);
        else if (a._altFlach && a._altFlach.indexOf(qFlach) === 0) punkte = Math.max(punkte, 2.2);
        else if (qFlach.length >= 5 && a._skuFlach.indexOf(qFlach) > 0) punkte = Math.max(punkte, 1.6);
      }

      if (punkte >= SCHWELLE) ergebnis.push({ a: a, p: punkte });
    }

    ergebnis.sort(function (x, y) {
      if (y.p !== x.p) return y.p - x.p;
      return x.a.titel.localeCompare(y.a.titel, 'de');
    });

    // Klarer Sieger: wer eine Artikelnummer eintippt, hat sie vom Aufkleber
    // abgelesen und will genau diesen Artikel. Die schwachen Zufallstreffer,
    // die die Trigramm-Ähnlichkeit auf Ziffernfolgen noch auswirft, wären
    // hier nur Rauschen ("WA003000" lieferte sonst 13 statt 1 Treffer).
    if (ergebnis.length && ergebnis[0].p >= 2.0) {
      ergebnis = ergebnis.filter(function (t) { return t.p >= 1.5; });
    }

    return ergebnis.slice(0, MAX_TREFFER);
  }

  /* ------------------------------------------------------------------
     Ansicht
     ------------------------------------------------------------------ */
  function el(id) { return WURZEL.querySelector('#' + id); }

  function grundgeruest() {
    WURZEL.innerHTML =
      '<div class="hilfe__inhalt">' +
        '<header class="hilfe__kopf">' +
          '<h1>Hilfe und Anleitungen</h1>' +
          '<p>Gib die Nummer vom Aufkleber ein oder such einfach nach dem Artikel.</p>' +
        '</header>' +

        '<div class="hilfe__suchbereich">' +
          '<div class="hilfe__suchspalte">' +
          // V3: Suchfeld und Tipp stehen in einem eigenen Container. Er ist
          // neben der Trefferkarte das einzige Element der Seite, das einen
          // bekommt. Alles andere läuft ohne Kasten, damit die Seite eine
          // Rangfolge hat statt eines Kachelteppichs.
          '<div class="hilfe__suchbox">' +
          '<div class="hilfe__suchfeld">' +
            '<svg class="hilfe__lupe" viewBox="0 0 24 24" fill="none" stroke="currentColor" ' +
              'stroke-width="2" stroke-linecap="round" aria-hidden="true">' +
              '<circle cx="11" cy="11" r="7"></circle><path d="M20 20l-3.5-3.5"></path></svg>' +
            '<input id="hilfe-eingabe" type="search" autocomplete="off" autocapitalize="off" ' +
              'spellcheck="false" enterkeyhint="search" aria-label="Artikel suchen" ' +
              // Kurz genug, dass der Platzhalter auch auf einem schmalen Handy
              // vollständig zu lesen ist. In V1 brach er bei 430 px ab, in V2
              // erneut, weil das Feld seit V3 in einem Container mit eigenem
              // Innenabstand sitzt. Deshalb jetzt ohne das Wort "eingeben".
              'placeholder="Nummer oder Artikelname">' +
            '<button type="button" class="hilfe__leeren" id="hilfe-leeren" ' +
              'aria-label="Suche leeren" hidden>&times;</button>' +
          '</div>' +
          // Der Hinweis steht bewusst AUSSERHALB von .hilfe__suchfeld: Lupe und
          // Kreuz sitzen darin absolut auf halber Hoehe, ein zusätzlicher
          // Absatz haette sie nach unten geschoben.
          '<p class="hilfe__tipp">Tippfehler und einzelne Wortteile sind kein Problem. ' +
            'Du kannst auch nur nach dem Artikelnamen suchen.</p>' +
          '</div>' +
          '</div>' +
          // Bildunterschrift bewusst als echter Text und nicht im Bild: im Bild
          // hängt die Schriftgröße an der Bildbreite und war auf dem Handy
          // viel zu klein (Johns Rueckmeldung zu V1).
          (K.bildUrl
            ? '<figure class="hilfe__erklaerbild">' +
                '<img src="' + sichereUrl(K.bildUrl) + '" alt="Beispiel-Aufkleber: die Artikelnummer ' +
                'steht rot umrandet unter dem Strichcode" loading="lazy">' +
                '<figcaption>' +
                  '<strong>Der Aufkleber sitzt außen auf der Verpackung.</strong>' +
                  'Auf der Folie oder auf dem Karton, etwa 7 × 4 cm groß. Die Nummer ' +
                  'steht direkt unter dem Strichcode und beginnt mit MTT. Ältere ' +
                  'Aufkleber tragen noch die alte Nummer. Beide funktionieren hier in der Suche.' +
                '</figcaption>' +
              '</figure>'
            : '') +
        '</div>' +

        '<p class="hilfe__status" id="hilfe-status" role="status" aria-live="polite"></p>' +
        '<div class="hilfe__buehne" id="hilfe-buehne"></div>' +

        '<footer class="hilfe__fuss">' +
          'Kommst du nicht weiter? Schreib uns an ' +
          '<a href="mailto:support@myteslatuning.de">support@myteslatuning.de</a>. ' +
          'Mit Bestellnummer geht es am schnellsten.' +
        '</footer>' +
      '</div>';

    var eingabe = el('hilfe-eingabe');
    eingabe.addEventListener('input', function () {
      el('hilfe-leeren').hidden = !eingabe.value;
      LETZTE_SUCHE = eingabe.value;
      AKTUELLER_ARTIKEL = null;
      zeichnen();
    });
    eingabe.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { eingabe.value = ''; LETZTE_SUCHE = ''; el('hilfe-leeren').hidden = true; zeichnen(); }
    });
    el('hilfe-leeren').addEventListener('click', function () {
      eingabe.value = ''; LETZTE_SUCHE = ''; this.hidden = true;
      AKTUELLER_ARTIKEL = null; zeichnen(); eingabe.focus();
    });
  }

  function bildBlock(a, klasse) {
    if (!a.bild_url) {
      return '<div class="hilfe__bild hilfe__bild--leer ' + (klasse || '') + '"></div>';
    }
    return '<div class="hilfe__bild ' + (klasse || '') + '">' +
             '<img src="' + sichereUrl(a.bild_url) + '" alt="" loading="lazy">' +
           '</div>';
  }

  function skuZeile(a) {
    var t = '<span class="hilfe__sku"><strong>' + schuetzen(a.sku) + '</strong>';
    if (a.sku_alt) t += ' &middot; alt: ' + schuetzen(a.sku_alt);
    return t + '</span>';
  }

  function trefferListe(treffer) {
    return treffer.map(function (t) {
      var a = t.a;
      return '<button type="button" class="hilfe__karte" data-sku="' + schuetzen(a.sku) + '">' +
        bildBlock(a) +
        '<span class="hilfe__karte-text">' +
          '<span class="hilfe__titel">' + schuetzen(a.titel) + '</span>' +
          (a.variante ? '<span class="hilfe__variante">' + schuetzen(a.variante) + '</span>' : '') +
          (a.kurzbeschreibung ? '<span class="hilfe__kurz">' + schuetzen(a.kurzbeschreibung) + '</span>' : '') +
          skuZeile(a) +
        '</span>' +
      '</button>';
    }).join('');
  }

  function faqBlock(liste) {
    if (!liste.length) return '';
    return '<div class="hilfe__faq">' + liste.map(function (f) {
      return '<details><summary>' + schuetzen(f.frage) + '</summary>' +
             '<p class="hilfe__antwort">' + schuetzen(f.antwort) + '</p></details>';
    }).join('') + '</div>';
  }

  /** Sehr kleiner Markdown-Ersatz für Anleitungen: Absätze, Listen, fett. */
  function anleitungHtml(text) {
    var bloecke = String(text).split(/\n{2,}/);
    return bloecke.map(function (b) {
      var zeilen = b.split('\n').filter(function (z) { return z.trim(); });
      var istListe = zeilen.length > 0 && zeilen.every(function (z) { return /^\s*([-*]|\d+\.)\s+/.test(z); });
      if (istListe) {
        return '<ul>' + zeilen.map(function (z) {
          return '<li>' + fett(schuetzen(z.replace(/^\s*([-*]|\d+\.)\s+/, ''))) + '</li>';
        }).join('') + '</ul>';
      }
      return '<p>' + fett(schuetzen(b.replace(/\n/g, ' '))) + '</p>';
    }).join('');
  }
  function fett(s) { return s.replace(/\*\*([^*]+)\*\*/g, '<strong>$1</strong>'); }

  /* ------------------------------------------------------------------
     Die vier Zustände: Start, Treffer, Detail, Formular/Danke
     ------------------------------------------------------------------ */
  /** Das Erklärbild hilft beim Suchen. Sobald der Artikel gefunden ist oder
   *  das Formular offen steht, ist es nur noch Weg zum Scrollen. Es wird
   *  deshalb ausgeblendet, das Suchfeld bleibt. */
  function ErklärbildZeigen(ja) {
    var f = WURZEL.querySelector('.hilfe__erklaerbild');
    if (f) f.hidden = !ja;
    var t = WURZEL.querySelector('.hilfe__tipp');
    if (t) t.hidden = !ja;
    // Ohne Bild gibt es am Desktop keine zweite Spalte mehr. Ohne diese
    // Klasse bliebe rechts neben Detail und Formular eine leere Fläche.
    var inhalt = WURZEL.querySelector('.hilfe__inhalt');
    if (inhalt) {
      if (ja) inhalt.classList.remove('hilfe__inhalt--breit');
      else inhalt.classList.add('hilfe__inhalt--breit');
    }
  }

  function zeichnen() {
    var buehne = el('hilfe-buehne');
    var status = el('hilfe-status');

    if (AKTUELLER_ARTIKEL) {
      status.textContent = '';
      ErklärbildZeigen(false);
      buehne.innerHTML = detailHtml(AKTUELLER_ARTIKEL);
      verdrahtenDetail();
      return;
    }
    ErklärbildZeigen(true);

    if (!LETZTE_SUCHE.trim()) {
      status.textContent = '';
      buehne.innerHTML =
        '<section class="hilfe__abschnitt">' +
          '<h2>Häufige Fragen</h2>' + faqBlock(FAQ_GLOBAL) +
        '</section>' +
        '<section class="hilfe__abschnitt">' +
          '<div class="hilfe__leer">' +
            '<strong>Du hast eine Frage zu einem Artikel?</strong><br>' +
            'Tipp die Nummer vom Aufkleber oben ein, dann siehst du direkt die passenden Infos. ' +
            'Geht auch mit dem Artikelnamen, zum Beispiel Fußmatten.' +
          '</div>' +
          '<div class="hilfe__knopfreihe" style="margin-top:14px">' +
            '<button type="button" class="hilfe__knopf hilfe__knopf--zweit" id="hilfe-allgemein">' +
              'Allgemeine Frage stellen</button>' +
          '</div>' +
        '</section>';
      var b = el('hilfe-allgemein');
      if (b) b.addEventListener('click', function () { formularZeigen(null); });
      return;
    }

    LETZTE_TREFFER = suchen(LETZTE_SUCHE);

    if (!LETZTE_TREFFER.length) {
      status.textContent = 'Keine Treffer für ' + LETZTE_SUCHE.trim();
      buehne.innerHTML =
        '<section class="hilfe__abschnitt">' +
          '<div class="hilfe__leer">' +
            '<strong>Dazu haben wir nichts gefunden.</strong><br>' +
            'Versuch es mit einem einzelnen Wort, zum Beispiel Matte, Halter oder Licht. ' +
            'Oder frag uns direkt, dann ordnen wir den Artikel für dich zu.' +
          '</div>' +
          '<div class="hilfe__knopfreihe" style="margin-top:14px">' +
            '<button type="button" class="hilfe__knopf" id="hilfe-allgemein">Frage stellen</button>' +
          '</div>' +
        '</section>';
      el('hilfe-allgemein').addEventListener('click', function () { formularZeigen(null); });
      return;
    }

    status.textContent = LETZTE_TREFFER.length === 1
      ? 'Ein Treffer'
      : LETZTE_TREFFER.length + ' Treffer';

    buehne.innerHTML =
      '<section class="hilfe__abschnitt">' +
        '<div class="hilfe__treffer">' + trefferListe(LETZTE_TREFFER) + '</div>' +
      '</section>';

    Array.prototype.forEach.call(buehne.querySelectorAll('.hilfe__karte'), function (k) {
      k.addEventListener('click', function () { artikelOeffnen(k.getAttribute('data-sku')); });
    });
  }

  function artikelFinden(sku) {
    for (var i = 0; i < ARTIKEL.length; i++) if (ARTIKEL[i].sku === sku) return ARTIKEL[i];
    return null;
  }

  function artikelOeffnen(sku) {
    var a = artikelFinden(sku);
    if (!a) return;
    AKTUELLER_ARTIKEL = a;
    adresseSetzen(sku);
    zeichnen();
    WURZEL.scrollIntoView({ block: 'start', behavior: 'smooth' });
  }

  /** Dateigröße für Menschen: 480 KB, 2,4 MB. Deutsches Komma. */
  function groesseText(bytes) {
    var b = Number(bytes || 0);
    if (!b) return '';
    if (b < 1024 * 1024) return Math.round(b / 1024) + ' KB';
    return (Math.round(b / 104857.6) / 10).toString().replace('.', ',') + ' MB';
  }

  function datumText(iso) {
    var m = /^(\d{4})-(\d{2})-(\d{2})/.exec(String(iso || ''));
    return m ? (m[3] + '.' + m[2] + '.' + m[1]) : '';
  }

  /** Abschnitt "Anleitung". Ohne hinterlegtes Dokument steht hier ein
   *  ehrlicher Platzhalter statt eines Knopfes, der ins Leere führt. */
  function anleitungBlock(a) {
    var html = '<div class="hilfe__block"><h3>Anleitung</h3>';
    var doks = (a.anleitungen || []).filter(function (d) { return sichereUrl(d.url); });

    if (doks.length) {
      html += '<div class="hilfe__anleitung-liste">' + doks.map(function (d) {
        var zusatz = [];
        if (d.typ) zusatz.push(String(d.typ).toUpperCase());
        if (d.groesse) zusatz.push(groesseText(d.groesse));
        if (d.stand) zusatz.push('Stand ' + datumText(d.stand));
        return '<a class="hilfe__dokument" href="' + sichereUrl(d.url) + '" ' +
               'target="_blank" rel="noopener" download>' +
                 '<span class="hilfe__dokument-text">' +
                   '<b>' + schuetzen(d.titel || 'Anleitung') + '</b>' +
                   (zusatz.length ? '<span>' + schuetzen(zusatz.join(' · ')) + '</span>' : '') +
                 '</span>' +
                 '<span class="hilfe__dokument-pfeil" aria-hidden="true">&darr;</span>' +
               '</a>';
      }).join('') + '</div>';
      if (a.anleitung_text) html += anleitungHtml(a.anleitung_text);
    } else if (a.anleitung_text) {
      html += anleitungHtml(a.anleitung_text);
      if (sichereUrl(a.anleitung_url)) {
        html += '<p><a href="' + sichereUrl(a.anleitung_url) + '" target="_blank" ' +
                'rel="noopener">Anleitung als Datei öffnen</a></p>';
      }
    } else if (sichereUrl(a.anleitung_url)) {
      html += '<p><a href="' + sichereUrl(a.anleitung_url) + '" target="_blank" ' +
              'rel="noopener">Anleitung öffnen</a></p>';
    } else {
      html += '<p class="hilfe__platzhalter">Für diesen Artikel schreiben wir die ' +
              'Anleitung gerade. Wenn du vorher etwas wissen willst, frag uns unten ' +
              'über das Formular. Wir antworten dir persönlich und schicken dir die ' +
              'Anleitung nach, sobald sie fertig ist.</p>';
    }
    return html + '</div>';
  }

  /** Einklappbarer Abschnitt. Zugeklappt, aber mit sichtbarer Anzahl,
   *  damit man sieht, dass es die Fragen gibt.
   *
   *  Die erste Zeile ist in V3 die wichtigste der ganzen Datei: ohne
   *  Fragen entsteht KEIN Abschnitt. Keine Überschrift, kein leerer
   *  Kasten, kein "Zu diesem Artikel liegen noch keine Fragen vor".
   *  Nichts. */
  function klappBlock(titel, liste, offen) {
    if (!liste.length) return '';
    return '<details class="hilfe__klapp"' + (offen ? ' open' : '') + '>' +
             '<summary>' + schuetzen(titel) +
               '<span class="hilfe__anzahl">' + liste.length + '</span>' +
             '</summary>' +
             '<div class="hilfe__klapp-inhalt">' + faqBlock(liste) + '</div>' +
           '</details>';
  }

  /** Fragen zu genau diesem Artikel: erst die artikelgenauen, dann die der
   *  Produktgruppe. Beide zusammen sind "Fragen zu diesem Artikel".
   *
   *  V3: Hier kommt heute nichts zurück, und das ist so gewollt. Der
   *  ausgelieferte Index enthält keine Gruppenfragen mehr, weil die 62
   *  erfundenen aus V2 draussen sind. Sobald John echte Kundenfragen in
   *  hilfe.faq pflegt (quelle 'kunde' oder 'hand'), holt
   *  tools\faq-gruppen-ziehen.py sie in den Index, und der Abschnitt
   *  erscheint von selbst wieder. */
  function artikelFragen(a) {
    var liste = (FAQ_SKU[a.sku] || []).concat(a.gruppe ? (FAQ_GRUPPE[a.gruppe] || []) : []);
    return liste;
  }

  function detailHtml(a) {
    var faq = artikelFragen(a);
    var html =
      '<button type="button" class="hilfe__zurueck" id="hilfe-zurück">&larr; Zur Suche</button>' +
      '<div class="hilfe__detailkopf">' +
        bildBlock(a) +
        '<div>' +
          '<h2>' + schuetzen(a.titel) + '</h2>' +
          (a.variante ? '<span class="hilfe__variante">' + schuetzen(a.variante) + '</span><br>' : '') +
          skuZeile(a) +
          // Der Hinweis steckt in einem eigenen Block-Element, weil die Plakette
          // selbst inline-flex ist und sonst neben der Artikelnummer klebt.
          (a.elektro
            ? '<div><span class="hilfe__hinweis">Elektrogerät: ' +
              'gehört nicht in den Hausmüll</span></div>'
            : '') +
        '</div>' +
      '</div>';

    if (a.kurzbeschreibung) {
      html += '<div class="hilfe__block"><h3>Worum es geht</h3><p>' +
              schuetzen(a.kurzbeschreibung) + '</p>' +
              (a.produkt_url
                ? '<p><a href="' + sichereUrl(a.produkt_url) + '">Artikel im Shop ansehen</a></p>'
                : '') +
              '</div>';
    }

    html += anleitungBlock(a);

    // V3: Der Abschnitt "Fragen zu diesem Artikel" erscheint nur, wenn zu
    // diesem Artikel oder seiner Gruppe wirklich Fragen hinterlegt sind.
    // Heute ist das nirgends der Fall, also zeigt die Artikelansicht ihn
    // nicht. Die allgemeinen Fragen bleiben erreichbar, damit niemand für
    // "Wie schnell bekomme ich eine Antwort?" zurück zur Suche muss.
    html += klappBlock('Fragen zu diesem Artikel', faq, false);
    html += klappBlock('Allgemeine Fragen', FAQ_GLOBAL, false);

    html += '<div class="hilfe__knopfreihe">' +
              '<button type="button" class="hilfe__knopf" id="hilfe-fragen">' +
                'Frage zu diesem Artikel stellen</button>' +
              '<button type="button" class="hilfe__knopf hilfe__knopf--zweit" id="hilfe-chat" hidden>' +
                'Direkt im Chat fragen</button>' +
            '</div>';
    return html;
  }

  function verdrahtenDetail() {
    el('hilfe-zurück').addEventListener('click', function () {
      AKTUELLER_ARTIKEL = null; adresseSetzen(null); zeichnen();
    });
    el('hilfe-fragen').addEventListener('click', function () {
      formularZeigen(AKTUELLER_ARTIKEL);
    });
    chatKnopfPruefen(el('hilfe-chat'), AKTUELLER_ARTIKEL);
  }

  /* ------------------------------------------------------------------
     Übergabe an den Shopify-Chat (Shopify Inbox)
     Das Widget bietet keine Schnittstelle zum Vorbefüllen der Nachricht.
     Deshalb: Text in die Zwischenablage legen und den Chat öffnen, damit
     der Kunde ihn nur noch einfügen muss. Ist das Widget nicht da, bleibt
     der Knopf unsichtbar statt tot.
     ------------------------------------------------------------------ */
  function chatDa() {
    return !!(window.ShopifyChat ||
              document.querySelector('shopify-chat, #ShopifyChat, [id^="ShopifyChat"]'));
  }

  function chatKnopfPruefen(knopf, artikel) {
    if (!knopf) return;
    var zeigen = function () {
      if (!chatDa()) return false;
      knopf.hidden = false;
      return true;
    };
    if (!zeigen() && !CHAT_GEPRUEFT) {
      // Das Widget lädt nach. Zweimal nachschauen reicht, danach ist es weg.
      var versuche = 0;
      var timer = setInterval(function () {
        versuche++;
        if (zeigen() || versuche >= 6) { clearInterval(timer); CHAT_GEPRUEFT = true; }
      }, 700);
    }
    knopf.addEventListener('click', function () {
      var text = artikel
        ? 'Hallo, ich habe eine Frage zu ' + artikel.titel +
          (artikel.variante ? ' (' + artikel.variante + ')' : '') + ', Artikelnummer ' + artikel.sku + '. '
        : 'Hallo, ich habe eine Frage. ';
      // Erst melden, wenn wirklich kopiert wurde. writeText kann abgelehnt
      // werden, etwa ohne Berechtigung; dann greift der Rückfallweg, und wenn
      // auch der scheitert, sagen wir es ehrlich statt zu behaupten.
      kopieren(text).then(function (geklappt) {
        knopf.textContent = geklappt
          ? 'Text kopiert, im Chat einfügen'
          : 'Chat geöffnet, Artikelnummer ' + (artikel ? artikel.sku : '') + ' bitte angeben';
      });
      try {
        if (window.ShopifyChat && typeof window.ShopifyChat.open === 'function') {
          window.ShopifyChat.open();
        } else {
          var w = document.querySelector('shopify-chat, #ShopifyChat');
          if (w && typeof w.click === 'function') w.click();
        }
      } catch (e) { /* Der Kunde kann den Chat auch selbst öffnen. */ }
    });
  }

  /** Gibt ein Promise auf true/false zurück: hat das Kopieren geklappt? */
  function kopieren(text) {
    var altmodisch = function () {
      try {
        var f = document.createElement('textarea');
        f.value = text;
        f.setAttribute('readonly', '');
        f.style.position = 'absolute';
        f.style.left = '-9999px';
        document.body.appendChild(f);
        f.select();
        var ok = document.execCommand('copy');
        document.body.removeChild(f);
        return !!ok;
      } catch (e) { return false; }
    };

    try {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        return navigator.clipboard.writeText(text).then(
          function () { return true; },
          function () { return altmodisch(); }
        );
      }
    } catch (e) { /* Rückfall unten */ }

    var ergebnis = altmodisch();
    return (window.Promise ? Promise.resolve(ergebnis)
                           : { then: function (f) { f(ergebnis); } });
  }

  /* ------------------------------------------------------------------
     Support-Formular
     ------------------------------------------------------------------ */
  var EMAIL_RE = /^[^@\s]+@[^@\s]+\.[^@\s]{2,}$/;
  var MAX_NACHRICHT = 4000;

  function formularZeigen(artikel) {
    var buehne = el('hilfe-buehne');
    el('hilfe-status').textContent = '';
    ErklärbildZeigen(false);
    WURZEL.scrollIntoView({ block: 'start', behavior: 'smooth' });
    buehne.innerHTML =
      '<button type="button" class="hilfe__zurueck" id="hilfe-zurück">&larr; Zurück</button>' +
      '<form class="hilfe__formular" id="hilfe-form" novalidate>' +
        '<h3>Frage stellen</h3>' +
        '<p>Wir melden uns per E-Mail, in der Regel innerhalb weniger Stunden, ' +
          'spätestens innerhalb von 48 Stunden.</p>' +
        (artikel
          ? '<div class="hilfe__bezug">Deine Frage betrifft: <span class="hilfe__sku">' +
            schuetzen(artikel.sku) + '</span> &middot; ' + schuetzen(artikel.titel) + '</div>'
          : '') +

        feld('name', 'Dein Name', 'text', 'Vorname Nachname', true) +
        feld('email', 'E-Mail-Adresse', 'email', 'name@beispiel.de', true) +
        feld('bestellnummer', 'Bestellnummer', 'text', 'zum Beispiel 1234 (optional)', false) +

        '<div class="hilfe__feld" id="feld-nachricht">' +
          '<label for="hilfe-nachricht">Deine Nachricht' +
            '<span class="hilfe__zaehler" id="hilfe-zaehler">0 / ' + MAX_NACHRICHT + '</span>' +
          '</label>' +
          // aria-describedby zeigt auf den Fehlerabsatz darunter. Solange er
          // leer ist, liest eine Sprachausgabe nichts vor; sobald ein Fehler
          // drinsteht, gehört er zum Feld (Codex-Finding V3-5).
          '<textarea id="hilfe-nachricht" name="nachricht" maxlength="' + MAX_NACHRICHT + '" ' +
            'aria-describedby="fehler-nachricht" ' +
            'placeholder="Was können wir für dich tun?"></textarea>' +
          '<p class="hilfe__feldfehler" id="fehler-nachricht"></p>' +
        '</div>' +

        '<div class="hilfe__honig" aria-hidden="true">' +
          '<label for="hilfe-firmenzusatz">Firmenzusatz (bitte frei lassen)</label>' +
          '<input type="text" id="hilfe-firmenzusatz" name="firmenzusatz" tabindex="-1" autocomplete="off">' +
        '</div>' +

        '<div class="hilfe__knopfreihe">' +
          '<button type="submit" class="hilfe__knopf" id="hilfe-senden">Frage absenden</button>' +
        '</div>' +
        // role="alert" sorgt dafür, dass eine Sprachausgabe die Sammelmeldung
        // vorliest, sobald sie erscheint (Codex-Finding V3-5).
        '<p class="hilfe__meldung hilfe__meldung--fehler" id="hilfe-meldung" role="alert"></p>' +
      '</form>';

    el('hilfe-zurück').addEventListener('click', function () {
      if (artikel) { AKTUELLER_ARTIKEL = artikel; } else { AKTUELLER_ARTIKEL = null; }
      zeichnen();
    });

    var nachricht = el('hilfe-nachricht');
    nachricht.addEventListener('input', function () {
      el('hilfe-zaehler').textContent = nachricht.value.length + ' / ' + MAX_NACHRICHT;
    });

    el('hilfe-form').addEventListener('submit', function (e) {
      e.preventDefault();
      absenden(artikel);
    });

    var ersteFeld = el('hilfe-name');
    if (ersteFeld) ersteFeld.focus();
  }

  function feld(name, beschriftung, typ, platzhalter, pflicht) {
    return '<div class="hilfe__feld" id="feld-' + name + '">' +
      '<label for="hilfe-' + name + '">' + beschriftung +
        (pflicht ? '' : ' <span>(optional)</span>') + '</label>' +
      '<input type="' + typ + '" id="hilfe-' + name + '" name="' + name + '" ' +
        'aria-describedby="fehler-' + name + '" ' +
        'placeholder="' + schuetzen(platzhalter) + '" autocomplete="' +
        (name === 'email' ? 'email' : (name === 'name' ? 'name' : 'off')) + '">' +
      '<p class="hilfe__feldfehler" id="fehler-' + name + '"></p>' +
    '</div>';
  }

  /** Fehler an einem Feld setzen oder wegnehmen.
   *  Die Farbe allein reicht nicht: wer die Seite vorlesen lässt, braucht
   *  aria-invalid am Feld und den Fehlertext über aria-describedby daran
   *  gebunden (Codex-Finding V3-5). Das Attribut wird beim Beheben wieder
   *  entfernt, nicht auf "false" gesetzt, damit kein Zustand hängen bleibt. */
  function fehlerSetzen(name, text) {
    var f = el('feld-' + name);
    var p = el('fehler-' + name);
    if (!f || !p) return;
    var eingabe = f.querySelector('input, textarea');
    if (text) {
      f.classList.add('hilfe__feld--fehler');
      p.textContent = text;
      if (eingabe) eingabe.setAttribute('aria-invalid', 'true');
    } else {
      f.classList.remove('hilfe__feld--fehler');
      p.textContent = '';
      if (eingabe) eingabe.removeAttribute('aria-invalid');
    }
  }

  function prüfen() {
    var werte = {
      name: el('hilfe-name').value.trim(),
      email: el('hilfe-email').value.trim(),
      bestellnummer: el('hilfe-bestellnummer').value.trim(),
      nachricht: el('hilfe-nachricht').value.trim(),
      firmenzusatz: el('hilfe-firmenzusatz').value
    };
    var fehler = 0;

    if (werte.name.length < 2) { fehlerSetzen('name', 'Bitte trag deinen Namen ein.'); fehler++; }
    else if (werte.name.length > 120) { fehlerSetzen('name', 'Der Name ist zu lang.'); fehler++; }
    else fehlerSetzen('name', '');

    if (!werte.email) { fehlerSetzen('email', 'Ohne E-Mail-Adresse können wir nicht antworten.'); fehler++; }
    else if (!EMAIL_RE.test(werte.email) || werte.email.length > 200) {
      fehlerSetzen('email', 'Diese Adresse sieht nicht richtig aus.'); fehler++;
    } else fehlerSetzen('email', '');

    if (werte.bestellnummer.length > 40) {
      fehlerSetzen('bestellnummer', 'Die Bestellnummer ist zu lang.'); fehler++;
    } else fehlerSetzen('bestellnummer', '');

    if (werte.nachricht.length < 10) {
      fehlerSetzen('nachricht', 'Bitte schreib uns ein paar Worte mehr, mindestens zehn Zeichen.'); fehler++;
    } else if (werte.nachricht.length > MAX_NACHRICHT) {
      fehlerSetzen('nachricht', 'Die Nachricht ist zu lang. Bitte kürze sie auf ' +
                   MAX_NACHRICHT + ' Zeichen.'); fehler++;
    } else fehlerSetzen('nachricht', '');

    return { werte: werte, ok: fehler === 0 };
  }

  function absenden(artikel) {
    var meldung = el('hilfe-meldung');
    meldung.className = 'hilfe__meldung hilfe__meldung--fehler';
    var p = prüfen();
    if (!p.ok) {
      meldung.textContent = 'Bitte schau dir die markierten Felder noch einmal an.';
      meldung.classList.add('hilfe__meldung--an');
      var erstes = WURZEL.querySelector('.hilfe__feld--fehler input, .hilfe__feld--fehler textarea');
      if (erstes) erstes.focus();
      return;
    }
    meldung.classList.remove('hilfe__meldung--an');

    // Honigtopf: ausgefüllt heißt Bot. Wir tun so, als wäre alles gut,
    // damit der Bot nicht lernt, das Feld leer zu lassen.
    if (p.werte.firmenzusatz) { dankeZeigen('MTT-000000-0000', true); return; }

    var knopf = el('hilfe-senden');
    knopf.disabled = true;
    knopf.textContent = 'Wird gesendet …';

    var koerper = {
      sku: artikel ? artikel.sku : null,
      name: p.werte.name,
      email: p.werte.email,
      bestellnummer: p.werte.bestellnummer || null,
      nachricht: p.werte.nachricht,
      betreff: artikel ? ('Frage zu ' + artikel.sku + ' ' + artikel.titel).slice(0, 160) : 'Allgemeine Frage',
      firmenzusatz: ''
    };

    if (K.demo || !K.endpunkt) {
      // Vorschau ohne Deploy: nichts wird verschickt, der Ablauf ist aber
      // derselbe, damit John die Bestätigung wirklich sehen kann.
      setTimeout(function () {
        dankeZeigen('MTT-' + demoDatum() + '-0042', true);
      }, 450);
      return;
    }

    var kopf = { 'Content-Type': 'application/json' };
    if (K.anonKey) { kopf.apikey = K.anonKey; kopf.Authorization = 'Bearer ' + K.anonKey; }

    fetch(K.endpunkt, { method: 'POST', headers: kopf, body: JSON.stringify(koerper) })
      .then(function (r) {
        return r.json().catch(function () { return { ok: false, fehler: 'Antwort unlesbar' }; })
          .then(function (j) { return { status: r.status, daten: j }; });
      })
      .then(function (a) {
        if (a.daten && a.daten.ok && a.daten.vorgangsnummer) {
          dankeZeigen(a.daten.vorgangsnummer, false);
          return;
        }
        knopf.disabled = false;
        knopf.textContent = 'Frage absenden';
        meldung.textContent = (a.daten && a.daten.fehler)
          ? a.daten.fehler
          : 'Das hat leider nicht geklappt. Bitte versuch es gleich noch einmal oder ' +
            'schreib direkt an support@myteslatuning.de.';
        meldung.classList.add('hilfe__meldung--an');
      })
      .catch(function () {
        knopf.disabled = false;
        knopf.textContent = 'Frage absenden';
        meldung.textContent = 'Keine Verbindung. Bitte prüf dein Netz und versuch es noch einmal, ' +
                              'oder schreib an support@myteslatuning.de.';
        meldung.classList.add('hilfe__meldung--an');
      });
  }

  function demoDatum() {
    var d = new Date();
    var z = function (n) { return (n < 10 ? '0' : '') + n; };
    return z(d.getFullYear() % 100) + z(d.getMonth() + 1) + z(d.getDate());
  }

  /* Ab hier wird gesiezt. Das ist Absicht und Johns Regel: die Seite duzt wie
     der Shop, die Antwort aus dem Support kommt gesiezt. Die Bestätigung ist
     bereits der erste Satz dieser Antwort, deshalb wechselt der Ton genau hier
     und nicht erst in der Mail. */
  function dankeZeigen(nummer, demo) {
    el('hilfe-buehne').innerHTML =
      '<div class="hilfe__danke">' +
        '<div class="hilfe__haken">&#10003;</div>' +
        '<h2>Vielen Dank, Ihre Frage ist angekommen.</h2>' +
        '<p>Wir melden uns per E-Mail, in der Regel innerhalb weniger Stunden, ' +
        'spätestens innerhalb von 48 Stunden. Bitte notieren Sie sich die ' +
        'Vorgangsnummer, dann finden wir Ihre Anfrage sofort wieder.</p>' +
        '<div class="hilfe__vorgang">' + schuetzen(nummer) + '</div>' +
        (demo ? '<p class="hilfe__klein">Vorschau: es wurde nichts wirklich verschickt.</p>' : '') +
        '<div class="hilfe__knopfreihe" style="justify-content:center">' +
          '<button type="button" class="hilfe__knopf hilfe__knopf--zweit" id="hilfe-neu">' +
            'Zurück zur Suche</button>' +
        '</div>' +
      '</div>';
    el('hilfe-neu').addEventListener('click', function () {
      AKTUELLER_ARTIKEL = null;
      LETZTE_SUCHE = '';
      var e = el('hilfe-eingabe');
      if (e) { e.value = ''; el('hilfe-leeren').hidden = true; }
      adresseSetzen(null);
      zeichnen();
    });
  }

  /* ------------------------------------------------------------------
     Adresszeile: /hilfe?sku=MTT-CAMP springt direkt in den Artikel.
     Heute zeigen alle Aufkleber auf dieselbe Seite. Wenn später einmal
     artikelgenaue QR-Codes gedruckt werden, funktioniert das hier schon.
     ------------------------------------------------------------------ */
  function adresseSetzen(sku) {
    if (!window.history || !window.history.replaceState) return;
    try {
      var u = new URL(window.location.href);
      if (sku) u.searchParams.set('sku', sku); else u.searchParams.delete('sku');
      window.history.replaceState({ sku: sku || null }, '', u.toString());
    } catch (e) { /* alte Browser: dann eben ohne */ }
  }

  function skuAusAdresse() {
    try {
      var u = new URL(window.location.href);
      var s = u.searchParams.get('sku');
      if (s) return s.toUpperCase().trim();
      if (window.location.hash && window.location.hash.length > 1) {
        return decodeURIComponent(window.location.hash.slice(1)).toUpperCase().trim();
      }
    } catch (e) { /* egal */ }
    return null;
  }

  /* ------------------------------------------------------------------
     Start
     ------------------------------------------------------------------ */
  function daten(quelle) {
    indexBauen(quelle.artikel || []);
    FAQ_GLOBAL = [];
    FAQ_SKU = {};
    FAQ_GRUPPE = {};
    GRUPPEN = quelle.gruppen || {};
    (quelle.faq || []).forEach(function (f) {
      if (!f.sku) FAQ_GLOBAL.push(f);
      else { (FAQ_SKU[f.sku] = FAQ_SKU[f.sku] || []).push(f); }
    });
    var nachSort = function (a, b) { return (a.sortierung || 100) - (b.sortierung || 100); };
    FAQ_GLOBAL.sort(nachSort);
    Object.keys(FAQ_SKU).forEach(function (s) { FAQ_SKU[s].sort(nachSort); });

    // Fragen je Produktgruppe. Sie gelten für jeden Artikel dieser Gruppe,
    // damit nicht 138 mal dasselbe gepflegt werden muss.
    var g = quelle.faq_gruppen || {};
    Object.keys(g).forEach(function (name) {
      FAQ_GRUPPE[name] = (g[name] || []).slice().sort(nachSort);
    });
  }

  function starten() {
    WURZEL = document.getElementById('hilfe-app');
    if (!WURZEL) return;

    var los = function (quelle) {
      daten(quelle);
      grundgeruest();
      var sku = skuAusAdresse();
      if (sku && artikelFinden(sku)) {
        AKTUELLER_ARTIKEL = artikelFinden(sku);
        zeichnen();
      } else {
        zeichnen();
        var e = el('hilfe-eingabe');
        // Autofokus nur am Desktop: am Handy würde sofort die Tastatur
        // hochspringen und das Erklärbild verdecken.
        if (e && window.matchMedia && window.matchMedia('(min-width: 720px)').matches) e.focus();
      }
    };

    if (window.HILFE_INDEX) { los(window.HILFE_INDEX); return; }

    WURZEL.innerHTML = '<div class="hilfe__lade">Einen Moment, die Artikelliste wird geladen …</div>';
    fetch(K.indexUrl, { credentials: 'omit' })
      .then(function (r) { return r.json(); })
      .then(los)
      .catch(function () {
        WURZEL.innerHTML =
          '<div class="hilfe__inhalt"><div class="hilfe__leer">' +
          '<strong>Die Artikelliste konnte nicht geladen werden.</strong><br>' +
          'Bitte lad die Seite neu. Wenn es weiter nicht geht, schreib uns an ' +
          '<a href="mailto:support@myteslatuning.de">support@myteslatuning.de</a>.' +
          '</div></div>';
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', starten);
  } else {
    starten();
  }

  // Für Tests von außen greifbar machen (die Vorschau nutzt das nicht).
  window.HILFE_TEST = { falten: falten, suchen: suchen, aehnlich: aehnlich,
                        artikel: function () { return ARTIKEL; } };
})();
